export const API_ENDPOINTS = {
  //Mock API (json-server)
  CLIENT_TRAINEE_DASHBOARD_COURSES: (clientId: string) =>
    `/client-trainee-dashboard-courses/${clientId}`,
  CLIENT_TRAINEE_COURSE: (clientId: string, courseId: string) =>
    `/client-trainee/${clientId}/courses/${courseId}`,
  CLIENT_TRAINEE_COURSE_MODULES: (clientId: string, courseId: string) =>
    `/client-trainee/${clientId}/courses/${courseId}/modules`,
  CUSTOMERS: "/customers",

  // Users
  ME: "/me",
  USERS: "/users",
  USER_BY_ID: (id: string) => `/users/${id}`,
  USER_STATS: (id: string) => `/users/${id}/stats`,

  // Courses and Modules
  COURSES: "/courses",
  COURSE_BY_ID: (course_id: string) => `/courses/${course_id}`,
  MODULES: "/modules",
  MODULE_BY_ID: (module_id: string) => `/modules/${module_id}`,
  MODULE_COMPLETION: (module_id: string) => `/modules/${module_id}/completion`,
  ACTIVITIES: "/activities",
  ACTIVITY_BY_ID: (activity_id: string) => `/activities/${activity_id}`,

  // Agent Sessions
  AGENT_TOKEN: "/agent-token",

  //Simulations
  USER_SIMULATIONS: (userId: string) => `/users/${userId}/simulations`,
  ALL_SIMULATIONS: "/simulations",
  SIMULATION_URL: (simulationId: string, fileType: string) =>
    `/simulations/${simulationId}/url/${fileType}`,
  ALL_SCENARIOS: "/scenarios",
  CREATE_SCENARIO: "/scenarios",
  SCENARIO_BY_ID: (scenarioId: string) => `/scenarios/${scenarioId}`,
  UPDATE_SCENARIO: (scenarioId: string) => `/scenarios/${scenarioId}`,
  SIMULATION_AUDIO: (simulationId: string) =>
    `/simulations/${simulationId}/audio`,
  SIMULATION_TRANSCRIPT: (simulationId: string) =>
    `/simulations/${simulationId}/transcript`,
  SIMULATION_FEEDBACK: (simulationId: string) =>
    `/simulations/${simulationId}/feedback`,
  DELETE_SIMULATION: (simulationId: string) => `/simulations/${simulationId}`,

  //Prompts
  PROMPTS: "/prompts/",
  PROMPT_BY_NAME: (promptName: string) => `/prompts/${promptName}`,
  PROMPT_UPDATE: (promptName: string) => `/prompts/${promptName}`,

};
